import { useId, type SVGProps, type ReactElement } from 'react'

/** Icono de centro de ayuda del header — canvas 40×40. */
const Help = (props: SVGProps<SVGSVGElement>): ReactElement => {
    const maskId = `help-cut-${useId().replace(/:/g, '')}`

    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <mask
                id={maskId}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="40"
                height="40"
            >
                <rect width="40" height="40" fill="white" />
                <path
                    className="help-center-mask"
                    d="M16.8294 22.25L17.1855 20.9907C17.1855 20.9907 20.6929 21.1481 21.3397 18.8814C21.9866 16.6146 20.5326 15.4372 19.5178 14.9335C18.592 14.4738 15.8264 14.7131 15.5 17.5906"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    className="help-center-mask"
                    d="M16.7434 24.8661C16.7514 24.7804 16.7514 24.6862 16.7474 24.592C16.6952 23.7014 16.037 23.8813 16.0009 24.6948C15.9889 25.0288 16.0972 25.3627 16.2497 25.4569C16.4945 25.6111 16.7072 25.337 16.7434 24.8661Z"
                    stroke="black"
                    strokeWidth="2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </mask>
            <path
                d="M11.448 26.2707C11.448 26.2707 9.70314 27.9225 9.55827 28.6102C9.41339 29.2978 10.6984 28.8664 10.6984 28.8664L13.5267 27.909C13.5267 27.909 17.1738 29.7698 20.3738 28.5832C23.5737 27.3966 25.961 25.6302 26.7169 20.4929C27.4728 15.3556 22.7359 10.9598 18.1313 11.0003C14.4967 11.034 10.2827 12.8948 9.79762 19.603C9.79128 21.9421 10.3605 24.2418 11.448 26.2707Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeMiterlimit="10"
                mask={`url(#${maskId})`}
            />
            <path
                d="M27.4531 11L25.9531 12.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M29.7031 13.25L27.4531 14.75"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M30.4531 16.25H28.2031"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default Help
